/**
 * 趣味测试页面路由
 */
import {loadPageFail} from '../lib/units';

export default [

  {
      name: 'answer',
      path: '/ceshi/:id/answer',
      meta: {
          title: '趣味测试答题页'
      },
      component: resolve => require(['../pages/ceshi/funanswer'], resolve, (err)=>{
          loadPageFail({
              pagename: '趣味测试答题页',
              err
          })
      })
  }
]



// WEBPACK FOOTER //
// ./src/router/ceshi.js